import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickReviewLike = (review: GoodsReview) => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_REVIEW_LIKE',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        GOODS_SNO: review.goods_sno,
        REVIEW_SNO: review.sno,
      },
    });
  }, [review.goods_sno, review.sno]);
};
